import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get as _get } from 'lodash';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import CMCRow from './cmcrow';

const CMCTable = (props) => {
    const navigate = useNavigate();
    const [, setMetrics] = useState([]);

    useEffect(() => {
        const metrics = [
            {
                label: 'CPU',
                min: 0,
                max: Object.values(_get(props.cmc, 'health_metrics.system.cpuinfo.total', {}))
                    .reduce((a, c) => a + c, 0),
                value: Object.entries(_get(props.cmc, 'health_metrics.system.cpuinfo.total', {}))
                    .filter(([k, v]) => k !== 'idle')
                    .reduce((a, [k, v]) => a + v, 0),
            },
            {
                label: 'Memory',
                min: 0,
                max: _get(props.cmc, 'health_metrics.system.meminfo.total_memory', 0),
                value: _get(props.cmc, 'health_metrics.system.meminfo.total_memory', 0) -
                    _get(props.cmc, 'health_metrics.system.meminfo.avail_memory', 0),
            },
            {
                label: 'Disk',
                min: 0,
                max: (_get(props.cmc, 'health_metrics.disks') || [])
                    .find(d => d.mount_point === '/') ? 100 : 0,
                value: 100 * ((_get(props.cmc, 'health_metrics.disks') || [])
                    .find(d => d.mount_point === '/') || { utilization: 0 }).utilization,
                pct: true,
            },
        ];
        setMetrics(metrics);
    }, [props.cmc]);

    const handleCMCSelect = (uuid) => {
        navigate(`/cmcs/health/${uuid}`);
    };

    const handleCMCSettings = (uuid) => {
        navigate(`/cmcs/edit/${uuid}`);
    };

    const handleSensorSelect = (cmc, uuid) => {
        navigate(`/cmcs/sensor_health/${cmc}/${uuid}`);
    };

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell align="right">Host</TableCell>
                        <TableCell align="right">Model</TableCell>
                        <TableCell align="right">Version</TableCell>
                        <TableCell align="right">HA Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.cmcs.map((v, i) => <CMCRow
                        key={'cmcs-' + i}
                        row={v}
                        showIssues={props.showIssues}
                        expandAll={props.expandAll}
                        handleSelectCMC={handleCMCSelect}
                        handleCMCSettings={handleCMCSettings}
                        handleSelectSensor={handleSensorSelect}
                        policies={props.policies}
                        allJobs={props.allJobs}
                    />)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

CMCTable.propTypes = {
    cmc: PropTypes.object,
    cmcs: PropTypes.array.isRequired,
    policies: PropTypes.array.isRequired,
    allJobs: PropTypes.array.isRequired,
    handleSelect: PropTypes.func,
    handleUpdate: PropTypes.func,
    showIssues: PropTypes.bool,
    expandAll: PropTypes.bool,
};

export default CMCTable;
